$(function() {
  
  function renderCartNotificationProduct(key, title, image, variantTitle) {
  	return `<div id="shopify-section-cart-notification-product" class="shopify-section">
		<div id="cart-notification-product-${key}" class="cart-item">
          <div class="cart-notification-product__image global-media-settings">
			<img src="${image}" alt="Hard Rock" width="70" height="70" loading="lazy"> </div>
          <div>
            <h3 class="cart-notification-product__name h4">${title}</h3>
			${variantTitle ? `<dl>
              <div class="product-option">
                  <dt>Size: </dt>                
				  <dd>${variantTitle}</dd>              
              </div>
              </dl>`: ``
            }
          </div> 
       </div>
    </div>`
  }
  
  function renderCartBubble(cartItemCount) {
  	return `<div id="shopify-section-cart-icon-bubble" class="shopify-section">
       <svg xmlns="http://www.w3.org/2000/svg" width="18.395" height="17.627" viewBox="0 0 18.395 17.627">\n  <g id="Icon_feather-shopping-cart" data-name="Icon feather-shopping-cart" transform="translate(0.75 0.75)">\n    <path id="Path_3" data-name="Path 3" d="M13.536,30.768A.768.768,0,1,1,12.768,30,.768.768,0,0,1,13.536,30.768Z" transform="translate(-6.624 -15.409)" fill="none" stroke="#1d1d1d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>\n    <path id="Path_4" data-name="Path 4" d="M30.036,30.768A.768.768,0,1,1,29.268,30,.768.768,0,0,1,30.036,30.768Z" transform="translate(-14.677 -15.409)" fill="none" stroke="#1d1d1d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>\n    <path id="Path_5" data-name="Path 5" d="M1.5,1.5H4.572L6.63,11.783a1.536,1.536,0,0,0,1.536,1.236h7.465a1.536,1.536,0,0,0,1.536-1.236L18.4,5.34H5.34" transform="translate(-1.5 -1.5)" fill="none" stroke="#1d1d1d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>\n  </g>\n</svg>\n<span class="visually-hidden">Cart</span>
		<div class="cart-count-bubble"><span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden"> items</span>\n  </div>
    </div>
	`
  }

  function renderCartDrawer() {
    $("cart-drawer.drawer").addClass("animate active");
    $("body").addClass("overflow-hidden");
  }
  
  function getCart(callback) {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json', 
      success: function (data) {
      	callback(data)
      }
    });
  }
  
  $(document).on('click','.cart_btn', function(e){
    e.preventDefault();
    $(this).find(".loading__spinner").removeClass("hidden");
    $(this).addClass("loading");
    var cartNotification = new CartNotification();
    //cartNotification.setActiveElement(document.activeElement)
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: [{
          quantity: parseInt($(this).parents(".card-information").find('.quantity__input').val()),
          //id: parseInt($(this).parents('.card-information').find('.product-form__input input[type=radio]:checked').attr('data-variant'))
          id: parseInt($(this).parents('.card-information').find('.product-form__inputxxx select option:selected').attr('data-variant'))
        }]
      },
      dataType: 'json', 
      success: function (data) {
        //console.log('data', data)
        
        $("body").addClass("overflow-hidden");
        var items = data.items;
        if (items.length) {
          var key = items[0].key
          var image = items[0].image
          var title = items[0].product_title
          var variantTitle = items[0].variant_title

          $("cart-drawer").load(location.href + " cart-drawer>div", function() {
              $("cart-drawer.drawer").addClass("animate active");
              $("body").addClass("overflow-hidden");
              $("cart-drawer.drawer").removeClass("is-empty");
              $(".cart_btn").find(".loading__spinner").addClass("hidden");
              $(".cart_btn").removeClass("loading");
          });
          
          getCart((cartData)=>{
            cartNotification.renderContents({
              ...items[0],
              key: key,
              sections: {
                  // "CartDrawer-CartItems": renderCartNotificationProduct(key, title, image, variantTitle),
                  //"CartDrawer":renderCartDrawer(),
                  "cart-icon-bubble": renderCartBubble(cartData.item_count)
              }
            })
          })
          
          //$("body").addClass("overflow-hidden");
          //document.querySelector('cart-drawer').classList.add('animate', 'active');
          
        }
      }
    });
    
  })
})    